export const isVisibleCTA = ctaData => Boolean(ctaData) && (Boolean(ctaData.label) || Boolean(ctaData.picto));

export const isVisibleIcon = iconData => Boolean(iconData) && Boolean(iconData.name);

export const isVisibleDetails = (serviceIcon, csaIcon, extraDetails) =>
  isVisibleIcon(serviceIcon) || isVisibleIcon(csaIcon) || Boolean(extraDetails);
